import { Phone } from "lucide-react";
import { COMPANY } from "../lib/constants";

export default function StickyMobileCall() {
  return (
    <a
      data-testid="sticky-mobile-call"
      href={`tel:${COMPANY.phoneDigits}`}
      className="sm:hidden fixed bottom-4 left-4 right-4 z-40 flex items-center justify-center gap-2 bg-orange-600 text-white font-bold rounded-full px-6 py-4 shadow-2xl shadow-orange-900/30"
    >
      <Phone className="w-5 h-5" />
      Appeler maintenant · {COMPANY.phone}
    </a>
  );
}
